export function periodFor(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone, year: 'numeric', month: 'numeric', day: 'numeric',
  }).formatToParts(date);
  const value = (type) => Number(parts.find((part) => part.type === type).value);
  const localDay = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
  const mondayOffset = (localDay.getUTCDay() + 6) % 7;
  const mondayDay = Math.floor(localDay.getTime() / 86400000) - mondayOffset;
  return Math.floor((mondayDay - 4) / 7) * 2 + (mondayOffset >= 3 ? 1 : 0);
}

export function countFor(productId, period, minimum, maximum) {
  const lower = Math.max(1, Math.min(100, Math.trunc(Number(minimum))));
  const upper = Math.max(lower, Math.min(100, Math.trunc(Number(maximum))));
  if (!Number.isFinite(lower) || !Number.isFinite(upper) || !/^\d+$/.test(productId)) return null;
  let seed = 2166136261;
  for (const character of productId) {
    seed = Math.imul(seed ^ character.charCodeAt(0), 16777619) >>> 0;
  }
  return lower + ((seed % (upper - lower + 1) + period) % (upper - lower + 1));
}

if (typeof customElements !== 'undefined' && !customElements.get('sprplx-cart-activity')) {
  customElements.define('sprplx-cart-activity', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        if (this.dataset.available !== 'true') {
          this.hidden = true;
          return;
        }
        try {
          const period = periodFor(new Date(), this.dataset.timezone);
          const count = countFor(this.dataset.productId, period, this.dataset.min, this.dataset.max);
          if (count === null) {
            this.hidden = true;
            return;
          }
          const text = count === 1 ? this.dataset.one : this.dataset.other.replace('__COUNT__', String(count));
          this.querySelector('[data-cart-activity-text]').textContent = text;
          this.hidden = false;
        } catch {
          this.hidden = true;
        }
      };
      this.section = this.closest('.shopify-section, dialog');
      this.onVariantUpdate = (event) => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        this.dataset.available = String(event.detail?.resource?.available === true);
        this.update();
      };
      this.section?.addEventListener('variant:update', this.onVariantUpdate);
      this.update();
      this.timer = window.setInterval(this.update, 60000);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariantUpdate);
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
}
